"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilHelper = void 0;
const util = require("util");
const _ = require("lodash");
class UtilHelper {
    static promiseSleep(ms) {
        return new Promise((resolve) => (ms <= 0 ? setImmediate(resolve) : setTimeout(resolve, ms)));
    }
    static safeJsonStringify(data) {
        try {
            return JSON.stringify(data);
        }
        catch (e) {
            return util.inspect(data);
        }
    }
}
exports.UtilHelper = UtilHelper;
UtilHelper.onlyNonNull = _.partial(_.filter, _, _.isObject);
//# sourceMappingURL=util-helper.js.map